import type { Language } from '../../models/LandingPage'
import { openCookieSettings } from '../../utils/analytics'
import { Logo } from '../common/Logo'
import { SocialLinks } from '../common/SocialLinks'

type FooterProps = {
  language: Language
}

const footerCopy = {
  en: {
    legal: 'Legal',
    privacy: 'Privacy',
    cookies: 'Cookies',
    terms: 'Terms',
    cookieSettings: 'Cookie Settings',
  },
  it: {
    legal: 'Legale',
    privacy: 'Privacy',
    cookies: 'Cookie',
    terms: 'Termini',
    cookieSettings: 'Impostazioni cookie',
  },
}

export function Footer({ language }: FooterProps) {
  const copy = footerCopy[language]

  return <footer>
    <div className="container footer-grid">
      <div>
        <Logo href="/"/>
        <p>From the song you love to the tone you play.</p>
      </div>
      <div>
        <b>Product</b>
        <a href="/#how">How it works</a>
        <a href="/#demo">Demo</a>
        <a href="/#hardware">Hardware</a>
      </div>
      <div>
        <b>Company</b>
        <a href="/#roadmap">Roadmap</a>
        <a href="/#beta">Founding beta</a>
        <a href="mailto:hello@tonesignature.com">Contact</a>
      </div>
      <div>
        <b>{copy.legal}</b>
        <a href="/privacy">{copy.privacy}</a>
        <a href="/cookies">{copy.cookies}</a>
        <a href="/terms">{copy.terms}</a>
        <button className="footer-link" type="button" onClick={openCookieSettings}>{copy.cookieSettings}</button>
      </div>
    </div>
    <div className="container footer-bottom">
      <span>© 2026 ToneSignature. All rights reserved.</span>
      <SocialLinks label="Follow us" className="footer-social"/>
      <span>Made for guitar players.</span>
    </div>
  </footer>
}
